import { render, staticRenderFns } from "./ExchangeResult.vue?vue&type=template&id=3c34aea1&scoped=true&"
import script from "./ExchangeResult.vue?vue&type=script&lang=js&"
export * from "./ExchangeResult.vue?vue&type=script&lang=js&"
import style0 from "./ExchangeResult.vue?vue&type=style&index=0&id=3c34aea1&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3c34aea1",
  null
  
)

export default component.exports